<template>
  <footer class="hfooter">
    <div class="hfooter-main">

      <!-- Colonne gauche -->
      <div class="hfooter-brand">
        <img :src="logo" width="162" height="66" alt="Bitcoin Mastermind" class="hfooter-logo" />
        <p class="hfooter-hackathon-label">Hackathon 2026</p>
        <p class="hfooter-desc">
          L'évènement incontournable pour découvrir et maitriser les technologies Bitcoin au service de l'innovation africaine.
        </p>
        <div class="hfooter-social">
          <span class="hfooter-social-label">SUIVEZ-NOUS</span>
          <div class="hfooter-social-icons">
            <a href="https://twitter.com/btcmastermind_" target="_blank" class="hfooter-social-btn" aria-label="Twitter/X">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.738l7.73-8.835L1.254 2.25H8.08l4.258 5.63L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://t.me/+dk5wgUKNklo1YjNk" target="_blank" class="hfooter-social-btn" aria-label="Telegram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
            </a>
            <a href="https://www.linkedin.com/company/btcmastermind" target="_blank" class="hfooter-social-btn" aria-label="LinkedIn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
        </div>
      </div>

      <!-- Navigation -->
      <div class="hfooter-nav">
        <p class="hfooter-col-title">Navigation</p>
        <ul>
          <li><a href="#agenda">Programme</a></li>
          <li><a href="#technologies">Technologies</a></li>
          <li><a href="#prix">Prix</a></li>
          <li><router-link to="/partners/apply">Partenariats</router-link></li>
          <li><a href="#faq">FAQ</a></li>
        </ul>
      </div>

      <!-- Contact -->
      <div class="hfooter-contact">
        <p class="hfooter-col-title">Contact</p>
        <ul>
          <li>
            <span class="hfooter-contact-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
            </span>
            <div>
              <span class="hfooter-contact-label">Email</span>
              <span class="hfooter-contact-value">info@btcmastermind.xyz</span>
            </div>
          </li>
          <li>
            <span class="hfooter-contact-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.59 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.98 16.92z"/></svg>
            </span>
            <div>
              <span class="hfooter-contact-label">Téléphone</span>
              <span class="hfooter-contact-value">+229 0161757483</span>
            </div>
          </li>
          <li>
            <span class="hfooter-contact-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
            </span>
            <div>
              <span class="hfooter-contact-label">Lieu</span>
              <span class="hfooter-contact-value">Golden Tulip le Diplomate, Cotonou – Benin</span>
            </div>
          </li>
        </ul>
      </div>

    </div>

    <!-- Bas de page -->
    <div class="hfooter-bottom">
      <p>© 2026 Bitcoin Mastermind - Hackathon. Tous droits réservés.</p>
    </div>
  </footer>
</template>

<script>
import logo from "@/assets/icons/logo.png"

export default {
  name: "HackathonFooter",
  data() {
    return { logo }
  }
}
</script>

<style scoped>
.hfooter {
  background: #EDEEE8;
  width: 100%;
}

.hfooter-main {
  max-width: 1280px;
  margin: 0 auto;
  padding: 72px 64px 48px;
  display: flex;
  gap: 80px;
  align-items: flex-start;
}

/* Brand */
.hfooter-brand {
  flex: 1.2;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.hfooter-logo {
  display: block;
  margin-bottom: 4px;
}

.hfooter-hackathon-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #FF9211;
  margin: 0 0 16px;
}

.hfooter-desc {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #05246A;
  max-width: 300px;
  margin: 0 0 24px;
}

.hfooter-social {
  display: flex;
  align-items: center;
  gap: 16px;
}

.hfooter-social-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #05246A;
}

.hfooter-social-icons {
  display: flex;
  gap: 10px;
}

.hfooter-social-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #05246A;
  text-decoration: none;
  transition: opacity 0.2s;
}

.hfooter-social-btn:hover { opacity: 0.7; }

/* Navigation */
.hfooter-nav {
  flex: 0.8;
}

.hfooter-col-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #05246A;
  margin: 0 0 20px;
}

.hfooter-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.hfooter-nav ul li a {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #05246A;
  text-decoration: none;
  transition: opacity 0.2s;
}

.hfooter-nav ul li a:hover { opacity: 0.6; }

/* Contact */
.hfooter-contact {
  flex: 1;
}

.hfooter-contact ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.hfooter-contact ul li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.hfooter-contact-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #05246A;
}

.hfooter-contact > ul > li > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.hfooter-contact-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #05246A;
}

.hfooter-contact-value {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #05246A;
  opacity: 0.75;
}

/* Bottom bar */
.hfooter-bottom {
  border-top: 1px solid rgba(5, 36, 106, 0.12);
  padding: 20px 64px;
  text-align: center;
}

.hfooter-bottom p {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: #05246A;
  opacity: 0.6;
  margin: 0;
}

@media (max-width: 900px) {
  .hfooter-main {
    flex-direction: column;
    gap: 40px;
    padding: 48px 24px 32px;
  }
  .hfooter-bottom { padding: 20px 24px; }
}
</style>
